import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { setCurrency } from "@/lib/helpers";
import { useAuth } from "@/contexts/AuthContext";

import { devLog } from "@/lib/devLog";
const DEFAULTS = {
  currency_code: "INR",
  currency_symbol: "₹",
  tax_label: "GST",
  company_name: "",
};

const BillingSettingsContext = createContext({
  settings: DEFAULTS,
  refresh: () => {},
});

export function BillingSettingsProvider({ children }) {
  const { user } = useAuth();
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/payments/settings/billing");
      const merged = { ...DEFAULTS, ...data };
      setSettings(merged);
      // Push currency into the module-scoped helper so every fmtMoney() call
      // across the app (including deeply nested components) uses it.
      setCurrency(merged.currency_symbol, merged.currency_code);
    } catch (err) {
      // Endpoint requires auth — silently ignore if we're not authed yet.
      devLog("billing settings fetch skipped", err);
    }
  }, []);

  useEffect(() => {
    if (user && user !== false) refresh();
  }, [user, refresh]);

  return (
    <BillingSettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </BillingSettingsContext.Provider>
  );
}

export const useBillingSettings = () => useContext(BillingSettingsContext);
